import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Route, useLocation, Routes } from 'react-router-dom';
import { UserBadgeList } from './badge/UserBadgeList';
import { UserApplePage } from './apple/UserApplePage';
import { UserWarningList } from '../warning/UserWarningList';
import { UserLnbItem } from './UserLnbItem';
import { UserHistoryPage } from './history/UserHistoryPage';
import { UserWishBook } from './UserWishBook';
import UserFollowerList from './social/UserFollowerList';
import UserFollowingList from './social/UserFollowingList';
import { ActivityPage } from './ActivityPage';
import { UserProfileBox } from './apple/UserProfileBox';
import { UserModifyPage } from './modify/UserModifyPage';
import { UserLoginHistory } from './UserLoginHistory';
import { UserLeave } from './UserLeave';


const UserPage = () => {
    const location = useLocation();
    const pathname = useMemo(() => location.pathname, [location]);
    const auth = useSelector(state => state.auth);

    const { userCode, lnbCode } = useMemo(() => {
        const tempCode = pathname.split('/')[3];

        if (isNaN(tempCode)) return { userCode: auth.id, lnbCode: tempCode };
        return { userCode: Number(tempCode), lnbCode: pathname.split('/')[4] };
    }, [auth.id, pathname]);

    if (!auth.authenticated) return null;

    return (
        <div className="subpage userPage">
            <div id="contents" className="mypage myreading inner">
                <div id="lnb">
                    <UserProfileBox userId={userCode} />
                    <ul className="menu_list">
                        <UserLnbItem lnbCode={lnbCode} >독서사과</UserLnbItem>
                        <UserLnbItem lnbCode={lnbCode} path="/history" use={userCode === auth.id} >활동이력</UserLnbItem>
                        <UserLnbItem lnbCode={lnbCode} path={`/${userCode}/activity/bookreport`} use={userCode === auth.id} >독서활동</UserLnbItem>
                        <UserLnbItem lnbCode={lnbCode} path={`/${userCode}/badge`} use={userCode === auth.id} >활동뱃지</UserLnbItem>
                        <UserLnbItem lnbCode={lnbCode} path={`/${userCode}/warning`} use={userCode === auth.id && auth.scoreWarning > 0} >주의</UserLnbItem>
                        <UserLnbItem lnbCode={lnbCode} path={`/${userCode}/wishbook`} use={userCode === auth.id} >관심도서</UserLnbItem>
                        <UserLnbItem lnbCode={lnbCode} path={`/login`} >로그인 기록</UserLnbItem>
                        <UserLnbItem lnbCode={lnbCode} path={`/leave`} >회원탈퇴</UserLnbItem>
                    </ul>
                </div>


                <div className="content">
                    <Routes>
                        {userCode === auth.id &&
                            // 본인 계정일때만 볼 수 있어
                            <>
                                <Route path="" element={<UserApplePage userId={userCode} />} />
                                <Route path="/history" element={<UserHistoryPage />} />
                                <Route path="/login" element={<UserLoginHistory />} />
                                <Route path="/leave" element={<UserLeave />} />
                                <Route path="/modify/*" element={<UserModifyPage />} />
                                <Route path="/:user/warning" element={<UserWarningList />} />
                                <Route path="/:user/wishbook" element={<UserWishBook />} />
                            </>
                        }
                        <Route path="/:user/badge" element={<UserBadgeList />} />
                        <Route path="/:user/activity/*" element={<ActivityPage user={userCode} />} />

                        <Route path="/:user/follower" element={<UserFollowerList />} />
                        <Route path="/:user/following" element={<UserFollowingList />} />
                    </Routes>
                </div>

            </div>
        </div>
    );
}//UserPage

export default UserPage;